import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const unselectAll: ISVGPersonalProps = {
  viewBox: '0 0 28 28',
  content: (
    <>
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_3004"
            data-name="Rectangle 3004"
            width="19.641"
            height="19.641"
            transform="translate(0 0)"
            fill="currentColor"
          />
        </clipPath>
      </defs>
      <g id="unselect_all_icon" data-name="unselect all icon" transform="translate(18459.691 2947.492)">
        <rect
          id="Rectangle_2788"
          data-name="Rectangle 2788"
          width="28"
          height="28"
          transform="translate(-18459.691 -2947.492)"
          fill="none"
        />
        <g id="Group_4120" data-name="Group 4120" transform="translate(-18455.512 -2943.313)">
          <g id="Group_4119" data-name="Group 4119" transform="translate(0 0)" clipPath="url(#clip-path)">
            <path
              id="Path_7151"
              data-name="Path 7151"
              d="M18.349,0H1.291A1.292,1.292,0,0,0,0,1.291V18.349a1.292,1.292,0,0,0,1.291,1.291H18.349a1.292,1.292,0,0,0,1.291-1.291V1.291A1.292,1.292,0,0,0,18.349,0M18.3,18.3H1.345V1.345H18.3Z"
              transform="translate(0 0)"
              fill="currentColor"
            />
            <path
              id="Path_7152"
              data-name="Path 7152"
              d="M15.3,24.392a.666.666,0,0,0,.948,0L19.835,20.8l3.588,3.588a.672.672,0,0,0,.948-.952l-3.588-3.588,3.588-3.588a.673.673,0,0,0-.952-.952L19.832,18.9l-3.588-3.588a.673.673,0,1,0-.952.952l3.588,3.588L15.292,23.44a.674.674,0,0,0,0,.952Z"
              transform="translate(-10.018 -10.032)"
              fill="currentColor"
            />
          </g>
        </g>
      </g>
    </>
  ),
};
